
export default {
  init() {
    // JavaScript to be fired on all pages
    function scrollToHash(target){
      if( target.length ) {
        $('html, body').stop().animate({
          scrollTop: target.offset().top,
        }, 750);
      }
    }

    if(window.location.hash) {
      scrollToHash($(window.location.hash));
    }

    // For accessibility reasons use button if target is on same page, see below function
    $('a[href^="#"]').on('click', function(event) {
      if( ! $(this).attr('data-toggle') ) {
        event.preventDefault;
        scrollToHash($(this.getAttribute('href')));
      }
    });

    $('button[data-target]').on('click', function(event) {
      event.preventDefault;
      scrollToHash($(this.getAttribute('data-target')));
    });

    // Prevent image download
    $('body:not(.development-mode)').on('contextmenu', 'img', function() {
      return false;
    });

    $('.testimonial-slider').slick({
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      accessibility: true,
    });

    $('.read-more-link').click(function(e) {
      e.preventDefault();
      $('.read-more').toggle();
      if( $('.read-more').is(':visible') ){
        $(this).find('span').text('Read less');
        $(this).find('svg').addClass('fa-flip-vertical');
      } else {
        $(this).find('span').text('Read more');
        $(this).find('svg').removeClass('fa-flip-vertical');
      }
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js